import { useContext } from "react"
import { func, number } from "prop-types"
import { Box, StackView, Text } from "@planningcenter/tapestry-react"
import { colors } from "components/shared/admin_colors"
import RegisterableContext from "components/admin/registerable/context"
import AttendeeSelection from "./AttendeeSelection"

const AttendeeSelections = ({ signupTimeId = null, withSaveStatus }) => {
  const { registerable } = useContext(RegisterableContext)

  const signupTimeAttendeeTypeSelections = registerable.attendeeTypeSelections.filter(
    selection => selection.signupTimeId === signupTimeId && selection.count > 0
  )

  const attendeeTypeSelections = signupTimeAttendeeTypeSelections.filter(
    selection => !selection.waitlist
  )

  const waitlistAttendeeTypeSelections = signupTimeAttendeeTypeSelections.filter(
    selection => selection.waitlist
  )

  return (
    <Box>
      <StackView>
        {attendeeTypeSelections.map(attendeeTypeSelection => (
          <AttendeeSelection
            key={attendeeTypeSelection.id}
            attendeeTypeSelection={attendeeTypeSelection}
            canceled={registerable.isCanceled}
            className="attendeeSelection"
          />
        ))}
      </StackView>
      {waitlistAttendeeTypeSelections.length > 0 && (
        <Box
          padding={2}
          marginHorizontal={-2}
          backgroundColor={colors.neutral_100}
          borderRadius="0 0 3px 3px"
          className="waitlistContainer"
        >
          <Text marginBottom={2} size={3} weight={600} color={colors.neutral_700}>
            Waitlist
          </Text>

          <StackView gap={2}>
            {waitlistAttendeeTypeSelections.map(attendeeTypeSelection => (
              <AttendeeSelection
                key={attendeeTypeSelection.id}
                attendeeTypeSelection={attendeeTypeSelection}
                canceled={registerable.isCanceled}
                withSaveStatus={withSaveStatus}
              />
            ))}
          </StackView>
        </Box>
      )}
    </Box>
  )
}

AttendeeSelections.propTypes = {
  signupTimeId: number,
  withSaveStatus: func
}

export default AttendeeSelections
